// ChatbotComponent.js
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const ChatbotComponent = () => {
  const dispatch = useDispatch();
  const { loading, introData, error } = useSelector((state) => state.root || {});

  const { chatbotId } = introData;
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://chatling.ai/js/embed.js';
    script.async = true;
    script.setAttribute('data-id',` ${chatbotId}`);
    script.id = 'chatling-embed-script';
    document.body.appendChild(script);
  }, []);

  return <div id="chatling-container"></div>;
};

export default ChatbotComponent;
